/* -disable react/style-prop-object */
import React, { Component } from 'react';

// Components
import { FormattedNumber } from 'react-intl';
import Table from '../../../../../../../components/Table';

// css
import './styles.css';

export default class ScheduleDetailNFList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [
        { title: 'NF', width: '15%' },
        { title: 'Destinatário', width: '40%' },
        { title: 'Volume', alignment: 'right', width: '15%' },
        { title: 'Peso (kg)', alignment: 'right', width: '15%' },
        {
          title: 'Valor (R$)',
          width: '15%',
          alignment: 'right',
          format: 'currency',
        },
      ],
    };
  }

  _formatNfListTableArray = () =>
    this.props.data.map(nfObject => ({
      nf: `${nfObject.nf}-${nfObject.nfGroup}`,
      receiver: nfObject.destination.name,
      volumes: nfObject.volume,
      weight: nfObject.nfWeight,
      value: nfObject.nfValue,
    }));

  render() {
    return (
      <div className="ScheduleDetailNFList">
        <div className="ScheduleDetailNFList__header">
          <div className="ScheduleDetailNFList__header-item">
            <div className="ScheduleDetailNFList__header-item-title">
              Total NFs
            </div>
            {this.props.activeNfData.nfCount}
          </div>
          <div className="ScheduleDetailNFList__header-item">
            <div className="ScheduleDetailNFList__header-item-title">
              Total Volumes
            </div>
            {this.props.activeNfData.totalVolumes}
          </div>
          <div className="ScheduleDetailNFList__header-item">
            <div className="ScheduleDetailNFList__header-item-title">
              Peso Total
            </div>
            <FormattedNumber
              style="decimal"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={this.props.activeNfData.totalWeight}
            />{' '}
            kg
          </div>
          <div className="ScheduleDetailNFList__header-item">
            <div className="ScheduleDetailNFList__header-item-title">
              Valor Total
            </div>
            <FormattedNumber
              style="currency"
              currency="BRL"
              currencyDisplay="symbol"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={this.props.activeNfData.totalValue}
            />
          </div>
        </div>

        <div className="ScheduleDetailNFList__nf-table-container">
          <Table
            className="ScheduleDetailNFList__nf-table"
            isFetching={this.props.isFetching}
            error={this.props.error}
            headers={this.state.headers}
            data={this._formatNfListTableArray()}
          />
        </div>
      </div>
    );
  }
}
